module.exports = [
	{
		"detail": "",
		"id": 1,
		"name": "Overall Accessibility",
		"order": 1,
		"rating_required": true,
		"user_created": false
	},
	{
		"detail": "",
		"id": 4,
		"name": "Doorways",
		"order": 1001,
		"rating_required": false,
		"user_created": false
	},
	{
		"detail": "",
		"id": 13,
		"name": "Elevators",
		"order": 1002,
		"rating_required": false,
		"user_created": false
	},
	{
		"detail": "",
		"id": 3,
		"name": "Floor/Ground",
		"order": 1003,
		"rating_required": false,
		"user_created": false
	},
	{
		"detail": "",
		"id": 14,
		"name": "Handrails",
		"order": 1004,
		"rating_required": false,
		"user_created": false
	},
	{
		"detail": "",
		"id": 15,
		"name": "Parking",
		"order": 1005,
		"rating_required": false,
		"user_created": false
	},
	{
		"detail": "",
		"id": 12,
		"name": "Ramps",
		"order": 1006,
		"rating_required": false,
		"user_created": false
	},
	{
		"detail": "",
		"id": 5,
		"name": "Restrooms",
		"order": 1007,
		"rating_required": false,
		"user_created": false
	},
	{
		"detail": "",
		"id": 2,
		"name": "Routes",
		"order": 1008,
		"rating_required": false,
		"user_created": false
	},
	{
		"detail": "",
		"id": 6,
		"name": "Seating",
		"order": 1009,
		"rating_required": false,
		"user_created": false
	},
	{
		"detail": "",
		"id": 9,
		"name": "Signage",
		"order": 1010,
		"rating_required": false,
		"user_created": false
	},
	{
		"detail": "",
		"id": 11,
		"name": "Stairs",
		"order": 1011,
		"rating_required": false,
		"user_created": false
	},
	{
		"detail": "",
		"id": 16,
		"name": "Restaurant Features",
		"order": 12,
		"rating_required": false,
		"user_created": false
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Place/Elements.json
// module id = 1089
// module chunks = 0